export const RunTag = ({ designNo, runNumber, className = "", stamped = false }) => {
  return (
    <div
      data-testid="run-tag"
      className={`inline-flex flex-col border border-[#fafafa] bg-black/40 px-3 py-2 ${stamped ? "animate-stamp -rotate-2" : "-rotate-1"} ${className}`}
      style={{ boxShadow: "2px 2px 0 0 #000" }}
    >
      <span className="font-mono-stamp text-[10px] leading-tight text-[#a0a0a0]">
        RUN TAG / HAND STAMP
      </span>
      <div className="mt-1 flex items-baseline gap-3 font-mono-stamp text-xs">
        <span>DESIGN {designNo}</span>
        <span className="text-[#555]">|</span>
        <span>ITEM {runNumber}</span>
      </div>
    </div>
  );
};
